// file for handling the view state of the bs and leaderboard elements
import { writable } from "svelte/store";
import { getFromLocalStorage, saveToLocalStorage } from "./utils.js";
// Create writable stores
export const selectedLeaderboardView = writable(
  getFromLocalStorage("leaderboardView") || "graph",
);
export const selectedBenchmarksView = writable(
  getFromLocalStorage("benchmarksView") || "graph",
);

// Functions to handle toggle changes
export const handleLeaderboardViewToggle = (event) => {
  selectedLeaderboardView.set(event.detail);
  saveToLocalStorage("leaderboardView", event.detail);
};

export const handleBenchmarksViewToggle = (event) => {
  selectedBenchmarksView.set(event.detail);
  saveToLocalStorage("benchmarksView", event.detail);
};
